export const redirectTo = (path: string) => {
  // eslint-disable-next-line unicorn/prefer-location-assign
  window.location.href = path;
};
